import {OSS_BUCKET, URL_CONFIG} from '@/url_config';

const BASE_URL = URL_CONFIG.mi_url
const DOC_BASE_URL = "http://toolup.cn:54000";
const PDF_BASE_URL = "http://toolup.cn:10001";


const handleResponse = async (response) => {
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP Error ${response.status}: ${errorText}`);
    }
    return response.json();
};

export const visionInfoParse = async (file_info, project_id, visionKey="") => {
    const reqData = {...file_info}
    reqData['bucket'] = OSS_BUCKET
    reqData['oss_key'] = `${project_id}/${file_info.file_key}`
    reqData['vision_key'] = `${visionKey}`

    const response = await fetch(`${BASE_URL}/mi_ai/file/vision_info_parse`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(reqData),
    });
    return handleResponse(response);
};

